// extracted by mini-css-extract-plugin
export var actions = "_3i-0";
export var actionsContainer = "_3i-7";
export var border = "_3i-1";
export var childFullHeight = "_3i-f";
export var collapse = "_3i-2";
export var content = "_3i-a";
export var contentChild = "_3i-e";
export var fullscreen = "_3i-c";
export var hasLeftRadius = "_3i-k";
export var headerContainer = "_3i-3";
export var headerRow = "_3i-5";
export var hidePadding = "_3i-b";
export var navCollapsedGap = "_3i-l";
export var noScrollX = "_3i-m";
export var noScrollY = "_3i-n";
export var noTopPadding = "_3i-i";
export var optOutTopPadding = "_3i-d";
export var pageMain = "_3i-j";
export var pageOuter = "_3i-g";
export var pagePadding = "_3i-8";
export var pageScroll = "_3i-9";
export var profile = "_3i-o";
export var profileContainer = "_3i-p";
export var profileImage = "_3i-q";
export var profileMain = "_3i-r";
export var profileSubtitle = "_3i-t";
export var profileTitle = "_3i-s";
export var showLeftPadding = "_3i-h";
export var tabsPortalSlot = "_3i-6";
export var tabsWrapper = "_3i-4";
export var title = "_3i-u";